import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'

import Toasted from 'vue-toasted';
import VModal from 'vue-js-modal';
import money from 'v-money'
Vue.use(money)

import responsive from 'vue-responsive'
Vue.use(responsive)

import { BootstrapVue } from 'bootstrap-vue'
import VueYoutube from 'vue-youtube'

import Scrollspy from 'vue2-scrollspy';
var VueScrollTo = require('vue-scrollto');

Vue.config.productionTip = false

import "@/assets/scss/style.scss";
import "@/assets/css/materialdesignicons.min.css";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/fr'
import locale from 'element-ui/lib/locale'

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import '@fortawesome/fontawesome-free/css/all.min.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCar } from '@fortawesome/free-solid-svg-icons'

library.add(faCar)
Vue.component('font-awesome-icon', FontAwesomeIcon)

locale.use(lang)

Vue.use(ElementUI);

Vue.use(DatePicker);




Vue.use(VueYoutube)

Vue.use(Scrollspy);
Vue.use(VueScrollTo)
Vue.use(VModal);

Vue.use(Toasted)

// Install BootstrapVue
Vue.use(BootstrapVue)

sync(store, router)

new Vue({
    router,
    store,
    Toasted,
    render: h => h(App)
}).$mount("#app")
